/** Titre liste — distinct du site officiel (`Result_equipe_rwd`) pour mesurer l’usage de l’interface moderne dans GA. */
export const MODERN_LIST_PAGE_TITLE = 'interface moderne';

export const MODERN_TAB_PAGE_TITLES = {
	competitions: 'Compétitions — interface moderne',
	equipes: 'Équipes — interface moderne',
	joueurs: 'Joueurs — interface moderne',
	carriere: 'Carrière — interface moderne',
};

export function getOfficialTeamTitle({ teamName, category, club, teamNumber }) {
	const name = teamName?.trim() || 'Équipe';
	const cat = category?.trim() || '—';
	const clubName = club?.trim() || '—';
	const number = String(teamNumber ?? '').trim() || '—';
	return `Equipe - ${name} - ${cat} - ${clubName} - ${number}`;
}

export function getOfficialPlayerTitle({
	licenceCategory,
	licenceLevel,
	playerName,
	club,
	licence,
}, { kind = 'individuel' } = {}) {
	const prefix = kind === 'carriere' ? 'Carriere' : 'Individuel';
	const cat = (licenceCategory || licenceLevel || '').trim() || '—';
	const name = playerName?.trim() || 'Joueur';
	const clubName = club?.trim() || '—';
	const lic = licence?.trim() || '—';
	return `${prefix} - ${cat} - ${name} - ${clubName} - ${lic}`;
}

/**
 * @param {{
 *   selectedPlayer?: { licenceCategory?: string, licenceLevel?: string, playerName?: string, club?: string, licence?: string } | null,
 *   expandedTeam?: { teamName?: string, category?: string, club?: string, teamNumber?: string } | null,
 *   teamPreview?: { teamName?: string, category?: string, club?: string, teamNumber?: string } | null,
 *   mainTab?: 'competitions' | 'equipes' | 'joueurs' | 'carriere',
 *   selectedCareer?: { licenceCategory?: string, licenceLevel?: string, playerName?: string, club?: string, licence?: string } | null,
 *   competitionContext?: { zone?: string, championship?: string, category?: string } | null,
 * }} ctx
 */
export function resolveModernResultsPageTitle({
	selectedPlayer,
	expandedTeam,
	teamPreview,
	mainTab = 'equipes',
	selectedCareer,
	competitionContext,
}) {
	if (selectedPlayer) {
		return getOfficialPlayerTitle(selectedPlayer, { kind: 'individuel' });
	}
	if (mainTab === 'carriere' && selectedCareer) {
		return getOfficialPlayerTitle(selectedCareer, { kind: 'carriere' });
	}
	const team = expandedTeam || teamPreview;
	if (team?.teamName) {
		return getOfficialTeamTitle(team);
	}
	if (mainTab === 'competitions' && competitionContext?.championship) {
		return `Compétitions — ${competitionContext.championship} — interface moderne`;
	}
	return MODERN_TAB_PAGE_TITLES[mainTab] ?? MODERN_LIST_PAGE_TITLE;
}
